import React, { lazy } from 'react';
import glue from '../glue';
const AdminPages = ['pages', 'smartforms', 'users', 'medias', 'settings', 'dashboard']; //Login

const Login = lazy(() => import(
/* webpackChunkName: "login" */
'../ui/login')); // Admin Layout

const AdminLayout = lazy(() => import(
/* webpackChunkName: "admin-layout" */
'../ui/admin/AdminLayout')); // Page

const EditPage = lazy(() => import('../ui/admin/Pages/Edit'));
const ListPage = lazy(() => import('../ui/admin/Pages/List'));
const EditSettings = lazy(() => import('../ui/admin/Settings/Edit'));
const ListSettings = lazy(() => import('../ui/admin/Settings/List'));
const EditUsers = lazy(() => import('../ui/admin/Users/Edit'));
const ListUsers = lazy(() => import('../ui/admin/Users/List'));
const MediaExplorer = lazy(() => import('../ui/admin/Medias/MediasExplorer'));
const Dashboard = lazy(() => import('../ui/admin/dashboard'));
const FormDefinitionList = lazy(() => import('../ui/admin/Forms/definition/List'));
const FormDefinitionEdit = lazy(() => import('../ui/admin/Forms/definition/Edit'));
const ListDataset = lazy(() => import('../ui/admin/Forms/submissions/ListDataset'));
const ListSubmission = lazy(() => import('../ui/admin/Forms/submissions/ListSubmission'));
const AdminNotFound = lazy(() => import('../ui/admin/AdminNotFound'));
export const getGlueInternalRouteObject = function (filter) {
  let applicationAdminRoutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const adminActive = !filter || filter.some(e => AdminPages.includes(e));
  const routes = [...(!filter || filter.includes('login') ? [{
    path: '/login',
    element: React.createElement(Login, null),
    i18nDisable: true
  }] : []), ...(!filter || adminActive ? [{
    path: '/admin',
    element: React.createElement(AdminLayout, null),
    i18nDisable: true,
    children: [...(!filter || filter.includes('dashboard') ? [{
      index: true,
      element: React.createElement(Dashboard, null)
    }] : []), ...(!filter || filter.includes('pages') ? [{
      path: 'pages',
      element: React.createElement(ListPage, null)
    }, {
      path: 'pages/:id',
      element: React.createElement(EditPage, null)
    }] : []), ...(!filter || filter.includes('settings') ? [{
      path: 'settings',
      element: React.createElement(ListSettings, null)
    }, {
      path: 'settings/:key/:website',
      element: React.createElement(EditSettings, null)
    }] : []), ...(!filter || filter.includes('users') ? [{
      path: 'users',
      element: React.createElement(ListUsers, null)
    }, {
      path: 'users/:id',
      element: React.createElement(EditUsers, null)
    }] : []), ...(!filter || filter.includes('medias') ? [{
      path: 'medias',
      element: React.createElement(MediaExplorer, null)
    }] : []), ...(!filter || filter.includes('smartforms') && glue.isSmartFormEnabled() ? [{
      path: 'forms/definitions/:pk',
      element: React.createElement(FormDefinitionEdit, null)
    }, {
      path: 'forms/definitions/:pk/:slug',
      element: React.createElement(FormDefinitionEdit, null)
    }, {
      path: 'forms/definitions',
      element: React.createElement(FormDefinitionList, null)
    }, {
      path: 'forms/datasets',
      element: React.createElement(ListDataset, null)
    }, {
      path: 'forms/datasets/:slug',
      element: React.createElement(ListSubmission, null)
    }] : []), ...applicationAdminRoutes, {
      path: '*',
      element: React.createElement(AdminNotFound, null)
    }]
  }] : [])];
  return routes;
}; // Export Lazy Loaded Admin Layout to be overrides or extended in App projects

export { AdminLayout };